import { createHttpEndpoint } from '../../utils'

import type { GetShippingValidationThresholds } from './thresholds.types'

/**
 * Get validation thresholds for shipping rules management.
 *
 * @see {@link TODO}
 */
export const getShippingValidationThresholds =
  createHttpEndpoint<GetShippingValidationThresholds>({
    method: 'GET',
    operationId: 'getShippingValidationThresholds',
    path: '/bm/delivery-methods/v1/seller/:sellerId/validation-thresholds',
  })
